/* Copyright IBM Corp. 2018 */
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';

import { LoggerProxy } from '../services/logger/logger.service';
import { isNil, isNotNil, perfMeasure } from './../../utils';
import { DependencyService } from './../services/dependency/dependency.service';
import { WchService } from './../services/wch.service';

const LOGGER = 'WchNgServicesModule';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [],
  providers: [DependencyService, WchService]
})
export class WchNgServicesModule {
  /*
   * This contructor prevents the module from being imported multiple times.
   *
   * @param parentModule
   */
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: WchNgServicesModule,
    loggerService: LoggerProxy,
    depService: DependencyService
  ) {
    // measure
    const handle = perfMeasure(LOGGER);
    // do not allow recursive includes
    if (isNotNil(parentModule)) {
      throw new Error(
        'WchNgModule is already loaded. Import it in the AppModule only'
      );
    }
    // make sure the logger exists
    if (isNil(loggerService)) {
      throw new Error('Logger Service required');
    }
    // make sure the logger exists
    if (isNil(depService)) {
      throw new Error('Dependency Service required');
    }
    // done
    handle();
  }
}
